import api from './api.js';

export default {
  async login(email, password) {
    const { data } = await api.post('/auth/login', { email, password }, { _noRedirect: true });
    return data; // { token, user }
  },
  async logout() {
    try { await api.post('/auth/logout'); } catch {}
  },
  async me() {
    const { data } = await api.get('/auth/me');
    return data.user;
  },
};
